import React from 'react';
import './SimInfo.css';
import { formatDate } from './Utils';

// A trial's expiry is final; a paid subscription's is renewable and keeps working
// through a grace period after it. Labelling both "subscription" would tell an
// agent to wait for a renewal payment that can never arrive on a trial SIM.
const simLabel = (sim) => (sim.is_trial ? 'SIM trial until' : 'SIM subscription until');

// An account can hold several SIMs (an old trial next to a paid one), and the
// ICCID is what admin acts on — so show it whenever there is a choice to get wrong.
const SimInfo = ({ sims }) => {
  const showIccid = sims.length > 1;
  return (
    <ul className="sim-list">
      {sims.map((sim, index) => (
        <li key={index} className="sim-item">
          <p className="account-detail meta">
            <strong>{simLabel(sim)} </strong>
            <span className={sim.is_expired ? 'sim-expired' : 'sim-value'}>{formatDate(sim.expires_at)}</span>
            {sim.is_expired && <span className="sim-expired"> (expired)</span>}
          </p>
          {showIccid && <p className="account-detail meta sim-iccid">{sim.iccid}</p>}
        </li>
      ))}
    </ul>
  );
};

export default SimInfo;
